const intialState = {
  eventType: '',
  fieldId: '',
  value: ''
};

const inputValidationReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_INPUT_VALIDATION_ONBLUR':
      return {
        ...state,
        eventType: action.payload.eventType,
        fieldId: action.payload.fieldId,
        value: action.payload.value,
        rowIndex: action.payload.rowIndex
      };
    case 'GET_INPUT_VALIDATION_CLEAR':
      return {
        ...state,
        eventType: '',
        fieldId: '',
        value: ''
      };
    default:
      return state;
  }
};

export default inputValidationReducer;
